import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute, Router, RouterModule } from "@angular/router";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { BsModalService } from "ngx-bootstrap/modal";
import { ImageCroppedEvent, ImageCropperModule } from "ngx-image-cropper";
import { filter, Subscription } from "rxjs";
import { TruncatePipe } from 'src/app/pipe/TruncatePipe.pipe';
import { ApiService } from "src/app/services/api.service";
import { AppSettings } from "src/app/services/AppSettings";
import { CommonValues } from "src/app/services/commonValues";
import { GigsumoConstants } from "src/app/services/GigsumoConstants";
import { GigsumoService } from "src/app/services/gigsumoService";
import { SearchData } from "src/app/services/searchData";
import { UtilService } from "src/app/services/util.service";
import Swal from "sweetalert2";
import { PricePlanService } from "../../Price-subscritions/priceplanService";
import { CommonModalComponent } from '../user-management/common-modal/common-modal.component';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';
import { NavigationHeaderComponent } from '../navigation-header/navigation-header.component';


export interface Credentials {
  password: string;
  username: string;
}

@Component({
  selector: "app-business-banner",
  standalone: true,
  imports: [BsDropdownModule, 
    CommonModule,
    RouterModule,
    ImageCropperModule,
    TruncatePipe,
    CommonModalComponent
  ,
    NG_ICON_DIRECTIVES,
    NavigationHeaderComponent,
  ],
  templateUrl: "./business-banner.component.html",
  styleUrls: ["./business-banner.component.scss"],
})
export class BusinessBannerComponent implements OnInit, OnDestroy {
  @ViewChild("myFileInput") myFileInput;

  bannerdata;
  admindata;
  industryClass: any;
  adminflag: Boolean;
  follwing: Boolean = true;
  bannerflag: Boolean = false;
  businessid; 
  viewasmembers: Boolean = false;
  // Read live: after a login redirect straight to this page, the nav-bar
  // saves MemberShipType only after its plan call returns.
  get membershiptype() { return localStorage.getItem('MemberShipType'); }
  bannerimg: any = "";
  businesslogs: any = "";

  // Uploaded cover layered over the wireframe gradient + stripes, so the
  // gradient shows when there's no cover (src ends in "undefined") or it fails.
  get coverBackground(): string {
    const fallback = 'repeating-linear-gradient(45deg, transparent 0 20px, rgba(255,255,255,.04) 20px 40px), '
      + 'linear-gradient(135deg, #7C3AED 0%, #A78BFA 60%, #C4B5FD 100%)';
    return this.bannerimg?.src ? `url("${this.bannerimg.src}"), ${fallback}` : fallback;
  }
  banner;
  userData = [];

  userId = localStorage.getItem("userId");
  fileUploadName;
  imageChangedEvent: any = "";
  croppedImage: any = "";
  modalRef: any;
  fileToUpload: File;
  photoId;
  img: { src: string };
  isAdmin: any;
  isSuperAdmin: any;
  showModal: boolean = false;
  @Output() onAdd = new EventEmitter();
  @Output() adminviewEmit = new EventEmitter<string>();


  commonDatahide: any = {}

  @ViewChild('networktemplate', { static: true }) networktemplate: TemplateRef<any>;
  constructor(
    private util: UtilService, 
    private API: ApiService, 
    private router: Router,
    private modalService: BsModalService,
    private _activated_route: ActivatedRoute,
    private commonvalues: CommonValues,
    private searchData: SearchData, 
    private Gigsumoservice:GigsumoService,
    private planService: PricePlanService, 
  ) {}

  businessData: any = {};
  businessName:any
  businessDetails:any
  subscription: Subscription;

  ngOnInit() {
    this._activated_route.queryParams.subscribe((res) => {
      this.businessData = res;
      this.businessid = res.businessId;
      this.businessName= res.businessName;   
    });

    this.getbusinessId();
    this.companydetailsapicall();
    this.b2bconnectionstatus(); 

    this.subscription = this.commonvalues.trigger$
    .pipe(filter((shouldCallApi) => shouldCallApi))
    .subscribe(() => {
      this.companydetailsapicall();
    });

    // this.subscription = this.commonvalues.trigger$
    // .pipe(filter((shouldCallApi) => shouldCallApi))
    // .subscribe(() => {
    //   this.companydetailsapicall();
    // });
  }

  ownerbusinessId:any
  role:any
  b2bconnectionstatus(){
    var data = this.businessid ? this.businessid : localStorage.getItem('businessId');
    const apiUrl = `business/findBusinessConnectionStatus?businessId=${data}&userId=${this.userId}`;
    this.API.query(apiUrl).subscribe((res) => {
    this.connectionStatus=res.data.businessConnectionStatusData.connectionStatus
    }); 
  }

  getbusinessId() {
    const userId = localStorage.getItem('userId');
    this.util.startLoader();
    this.Gigsumoservice.getBusinessId(userId).subscribe(response => {
      this.util.stopLoader();
      this.ownerbusinessId = response.data&&response.data.businessData.businessId;
      this.role=response.data.role;
      this.businessDetails = {
        ...this.businessDetails, // Keep existing details
        id: response.data.businessData.businessId,
        businessEmail: response.data.businessData.businessEmail,
        businessName: response.data.businessData.businessName,
        bid: response.data.businessData.platformBusinesId,
        plan: response.data.businessData.subscriptionType
      };
      this.businessDetails = this.getNetworkParams(this.businessDetails);
    });
  }

  refreshBusinessList(eventData: { value: any, action: string }) {
    const { value, action } = eventData;
    this.connectionStatus = action=='create'?'REQUEST_SENT':'CONNECTED';
  }

  getNetworkParams(businessDetails){
    return {...businessDetails , contactBusinessId : this.businessid  };
  }

  ngOnDestroy(): void {
    if (this.sub1 != undefined) {
      this.sub1.unsubscribe();
    }

    if (this.subscription != undefined) {
      this.subscription.unsubscribe();
    }
  }

  removeUserContact() {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: { confirmButton: 'btn btn-success', cancelButton: 'btn btn-danger' },
      buttonsStyling: false
    })
    swalWithBootstrapButtons.fire({
      title: `Are you sure you want to remove ${this.businessName}?`,
      icon: 'warning',
      showCancelButton: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        this.util.startLoader();
        this.API.delete(`business/removeB2BContact/${this.ownerbusinessId}/${this.businessid}`).subscribe(
          (res) => {
            this.util.stopLoader();
            if (res.code === '00000') {
              Swal.fire({
                icon: 'success',
                title: 'Contact removed successfully',
                showConfirmButton: false,
                timer: 2000,
              }).then(() => {
                this.connectionStatus = 'NOT_CONNECTED';

              });
            }
          },
          (error) => {
            this.util.stopLoader();
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'Something went wrong. Please try again later.',
              showConfirmButton: false,
              timer: 4000,
            });
          }
        );
      }
    });
  }
  sendMessage() {
    var userData: any = {};
    userData.type = "BUSINESS";
    userData .refererId= this.businessid
    this.router.navigate(["message"], { queryParams: userData });
  }


  handleInvite( action: 'REJECT' | 'CANCEL') {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: { confirmButton: 'btn btn-success', cancelButton: 'btn btn-danger' },
      buttonsStyling: false
    })
    let contactStatus: string;
    let successMessage: string;

    switch (action) {
      case 'REJECT':
        contactStatus = "REJECTED";
        successMessage = "Contact request rejected";

        swalWithBootstrapButtons.fire({
          title: `Are you sure you want to reject ${this.businessName}?`,
          icon: 'warning',
          showCancelButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          reverseButtons: true
        }).then((result) => {
          if (result.isConfirmed) {
            this.processInvite( contactStatus, successMessage, action);
          }
        });
        break;

      case 'CANCEL':
        contactStatus = "CANCELLED";
        successMessage = "Contact request cancelled";
        this.processInvite( contactStatus, successMessage, action);
        break;

      default:
        contactStatus = "";
        successMessage = "";
    }
  }

  processInvite( contactStatus: string, successMessage: string, action: string) {
    const data = {
      businessId: this.ownerbusinessId,
        peerBusinessId: this.businessid,
        contactStatus: contactStatus,
    };

    this.util.startLoader();
    this.API.create("business/updateB2BContact", data).subscribe(
      (res) => {
        this.util.stopLoader();
        if (res.code == "00000") {
          Swal.fire({
            icon: "success",
            title: successMessage,
            showConfirmButton: false,
            timer: 2000,
          }).then(() => {
            this.connectionStatus ='NOT_CONNECTED';
          });
        } else {
          Swal.fire({
            icon: "info",
            title: "Oops...",
            text:
              action === 'REJECT'
                ? "Contact reject request failed. Please try after a while."
                : "Something went wrong. Please try after some time.",
            showConfirmButton: false,
            timer: 4000,
          });
        }
      },
      (error) => {
        this.util.stopLoader();
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Something went wrong. Please try again later.",
          showConfirmButton: false,
          timer: 4000,
        });
      }
    );
  }

  async getBusinessPLanBenefits() {
    const userPlan: any = await this.API.lamdaFunctionsget('findBusinessPlanBenefits/' + this.ownerbusinessId);
    const plan = userPlan.data.businessPlanAndBenefits.benefitsUsages;
    if (plan) {
      return plan.find(x => x.benefitKey === "B2B_CONTACTS");
    }
  }
  bannervalues:any
  selectedItem: string = 'businessContacts';
  async requestB2BContact(param) {
    const plan = await this.getBusinessPLanBenefits();
    if (plan.available > 0) {
      this.showModal = true;
      this.bannervalues=param
    } else {
      this.showModal = false;
      this.planService.expiredPopup(
        "B2B_CONTACTS",
        "PAY",
        null,
        null,
        null,
        null,
        plan.available,
        plan.actual,
        plan.utilized,
        plan.promotional
      );
      this.util.stopLoader();
    }
  }




  apicall(id) {
    this.util.startLoader();
    this.API.query('business/employee/request/pending/' + id).subscribe(res => {
      this.util.stopLoader();
      this.searchData.setRequestedEmployeeCount(res.data.pendingtList.length)
      localStorage.setItem("reqPendinCnt", res.data.pendingtList.length);
    });
  }
  closeModal(data?) {
    this.showModal = false;
    this.modalService.hide(this.modalService.getModalsCount());

  }

  followers() {
    const mergedParams = { ... this.businessData};
    const urlPath ='/business/follower';
     this.router.navigate([urlPath], {
      queryParams: mergedParams,
    });
  }
  connectionStatus:any;
  sub1: Subscription;

  /** Details-line social icons. Built once per load (not a getter) so *ngFor
   *  doesn't recreate the icons on every change detection (hover blink). */
  heroSocials: { key: string, label: string, url: string }[] = [];

  /** Location tooltip: "City, State", skipping whichever is missing. */
  get heroLocation(): string {
    const loc = this.bannerdata?.companyLocationDetails?.[0];
    return [loc?.city, loc?.state].filter(p => p && String(p).trim()).join(', ');
  }

  private buildHeroSocials(): { key: string, label: string, url: string }[] {
    const s = this.bannerdata?.userSocialPresence || {};
    return [
      { key: 'linkedin', label: 'LinkedIn', url: s.linkedin },
      { key: 'twitter', label: 'X / Twitter', url: s.twitter },
      { key: 'youtube', label: 'YouTube', url: s.youtube },
      { key: 'instagram', label: 'Instagram', url: s.instagram },
      { key: 'facebook', label: 'Facebook', url: s.facebook },
      { key: 'tiktok', label: 'TikTok', url: s.tiktok }
    ].filter(x => !!x.url)
      .map(x => ({ ...x, url: /^https?:\/\//i.test(x.url) ? x.url : 'http://' + x.url }));
  }

  trackBySocial(_: number, s: { key: string }): string {
    return s.key;
  }

  /** Page Health "Upload" → same file picker as the Edit Cover button. */
  openCoverPicker(): void {
    this.myFileInput?.nativeElement?.click();
  }

  /** Edit Profile / "+ Add" socials → About → Profile (holds the social form). */
  openProfileEdit(): void {
    this.router.navigate(['/business/about/profile'], { queryParamsHandling: 'merge' });
  }

  /** About → Profile with that edit modal opened (business-profile reads
   *  `openEdit`): about = description, details = business details (incl.
   *  state of incorporation), social = social links. */
  openProfileEditor(which: 'about' | 'details' | 'social'): void {
    this.router.navigate(['/business/about/profile'], {
      queryParams: { openEdit: which },
      queryParamsHandling: 'merge'
    });
  }
  companydetailsapicall() {
    this.viewasmembers = false;
    var data;
    data = this.businessid ? this.businessid : localStorage.getItem('businessId');
    this.util.startLoader();
    this.sub1 = this.API.query("business/details/" + data).subscribe((res) => {
    this.util.stopLoader();
      this.commonvalues.resetTrigger(); 
      this.bannerdata = res.data.businessModelList[0];
      this.heroSocials = this.buildHeroSocials();
      if (this.bannerdata.companyLocationDetails[0].website == undefined) {
        this.bannerdata.companyLocationDetails[0].website == "http://"
      }
      this.apicall(data)
      if (
        this.bannerdata != null &&
        this.bannerdata.industryClassification != null &&
        this.bannerdata.industryClassification != undefined
      ) {

        this.industryClass = this.bannerdata.industryClassification;
      }
      if (res.data.businessModelList[0].businessBanner != 'undefined' || res.data.businessModelList[0].businessLogo != 'undefined') {
        this.businesslogs = { src: AppSettings.photoUrl + res.data.businessModelList[0].businessLogo };
        this.bannerimg = { src: AppSettings.photoUrl + res.data.businessModelList[0].businessBanner };
        localStorage.setItem("businessBannerImage", res.data.businessModelList[0].businessBanner)
      }
      this.bannerdata.employees.forEach(element => {
        if (element.userId == localStorage.getItem('userId')) {
        }
      });
      this.bannerdata.followers.forEach(element => {
        if (element.userId == localStorage.getItem('userId')) {
        }

      });
      this.checkadmin(res.data.businessModelList[0].businessId, this.userId, res.data.businessModelList[0].businessName);
    }, err => {
      this.util.stopLoader();
    });
  }

  editbussiness() {
    this.bannerflag = true;
  }

  businessupdatedata() {
    this.bannerdata.userId = localStorage.getItem("userId");
    this.bannerdata.businessOwner = localStorage.getItem("userId");
    this.viewasmembers = false;
    this.util.startLoader();

    this.API.updatePut("business/update", this.bannerdata).subscribe((res) => {

      this.util.stopLoader();


      this.companydetailsapicall();

      var obj: any = {}
      obj.boolean = true
      this.commonvalues.setProfo(obj)
    }, err => {
      this.util.stopLoader();
    });
  }

  fileChangeEvent(event, popupName): void {
    this.imageChangedEvent = event;
    const acceptedImageTypes = ['image/gif', 'image/jpeg', 'image/png'];
    if (event.target.files && event.target.files[0]) {
      this.fileUploadName = event.target.files[0].name;
      this.myFileInput.nativeElement.value;
    }

    if (!acceptedImageTypes.includes(event.target.files[0].type)) {
      Swal.fire('', 'Please upload the correct file type   (Only .jpg, .png, .jpeg)', 'info');
      this.myFileInput.nativeElement.value = "";
      this.modalRef.hide();
    } else {
      this.PopupServicevlaues(popupName);
    }

  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    // //// console.log("this.v-- "+this.croppedImage.name);
    // //// console.log("this.croppedImage-- "+this.croppedImage);

    const byteString = window.atob(
      event.base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
    );
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: "image/jpeg" });

    this.fileToUpload = new File([blob], this.fileUploadName, {
      type: "image/jpeg",
    });
  }

  imageLoaded() {

    const formData: FormData = new FormData();
    formData.append("file", this.fileToUpload, this.fileUploadName);
    this.util.startLoader();
    this.API.create("upload/image", formData).subscribe((res) => {
      this.util.stopLoader();
      this.photoId = res.fileId;
      // this.modalRef.hide()
      this.modalclose();
      formData.delete("file");
      // this.bannerimg = {src :AppSettings.ServerUrl + 'download/' + this.photoId }
      if (res.fileId) {
        this.bannerdata.businessBanner = res.fileId;
        this.businessupdatedata();
        var commonData: any = {};
        commonData.bannerchanged = true;
        commonData.businessBanner = res.fileId;
        this.searchData.setBannerPhoto(commonData);
      }
    }, err => {
      this.util.stopLoader();
      if (err.status == 500) {
        this.util.stopLoader();
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: 'Something went wrong while uploading image. Please, try again later.',
          showDenyButton: false,
          confirmButtonText: `ok`,
        })
      }
    });

    this.bannerflag = false;
  }

  modalclose() {
    this.modalRef.hide();
    // for (let i = 1; i <= this.modalService.getModalsCount(); i++) {
    //   this.modalService.hide(i);
    // }
    this.myFileInput.nativeElement.value = "";

  }

  closePhoto() {
    this.modalRef.hide();
    this.myFileInput.nativeElement.value = "";
  }
  closemodal() {
    this.modalService.hide(1);
  }

  PopupServicevlaues(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {
      animated: true,
      backdrop: "static",
    });
  }

  cropperReady() {
    // cropper ready
  }
  loadImageFailed() {
    // show message
  }

  isAdminOrSuperAdmin(): boolean {
    return
  }

  requestsent:boolean=false
  sendEmployeeRequest() {
    if (this.requestsent) {
      return;
    }
    var data: any = {}
    data.userId = localStorage.getItem('userId')
    data.businessId = this.businessid
    this.requestsent=true;
    this.util.startLoader();
    this.API.create("business/employee/request/send", data).subscribe(res => {
      this.util.stopLoader();
      this.requestsent=false;
      if (res.code == "00000") {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Employee request sent successfully",
          showConfirmButton: false,
          timer: 2000,
        }).then((result) => {
          this.admindata.isEmployeeRequestSent=true;
          this.admindata.isEmployeeRequestRejected=false;
          this.admindata.isRevokedEmployee=false;
        });
      } else if (res.code == '99999') {
        Swal.fire({
          position: "center",
          icon: "info",
          title: "Oops...",
          text: "Sorry, something went wrong. Please try after some time.",
          showConfirmButton: false,
          timer: 5000,
        }).then((result) => {
        });
      }
    }, err => {
      this.util.stopLoader();
      if (err.status == 500) {
        this.util.stopLoader();
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: 'Something went wrong while sending employee request. Please, try again later.',
          showDenyButton: false,
          confirmButtonText: `ok`,
        })
      }
    })
  }

  commonVariables: any = {}
  checkadmin(businessid, userId, businessName) {
    const datas: any = {};
    datas.businessId = this.businessid;
    datas.userId = localStorage.getItem("userId");
    this.util.startLoader();
    this.API.create("business/check/admin", datas).subscribe((res) => {

      if(res.code === GigsumoConstants.SUCESSCODE){
        this.util.stopLoader();
        this.admindata = res;
        localStorage.setItem('isAFollower', res.isFollow);
        this.searchData.setCommonVariables(this.admindata);
        this.isSuperAdmin = localStorage.setItem("isSuperAdmin", res.isSuperAdmin);
        this.isSuperAdmin = localStorage.setItem("isAdmin", res.isAdmin);
        const data = {
          ...this.businessData ,
          isAdmin : String(res.isAdmin),
          isSuperAdmin : String(res.isSuperAdmin)
        }
        // Entry links without the role in the URL (e.g. SSR Companies → Follow)
        // leave the menu and tab pages, which read it from queryParams, in
        // member view — sync the checked role into the URL.
        const urlParams = this._activated_route.snapshot.queryParams;
        if (urlParams.isAdmin !== data.isAdmin || urlParams.isSuperAdmin !== data.isSuperAdmin) {
          this.router.navigate([], {
            relativeTo: this._activated_route,
            queryParams: { isAdmin: data.isAdmin, isSuperAdmin: data.isSuperAdmin },
            queryParamsHandling: 'merge',
            replaceUrl: true
          });
        }
        this.businessData = data;
        console.log("Business data " , this.businessData);
        
        if (this.admindata.isSuperAdmin) {
           this.isAdmin = this.isSuperAdmin; 
        } else if (this.admindata.isAdmin) {
  
        } 
        else {
          this.admindata.isAdmin = false;
          this.admindata.isSuperAdmin = false; 
        }

      }  
    }, err => {
      this.util.stopLoader();
    });
  }

  adminview() {

    const truncatedSctring = this.router.url.slice(0, 15);
    truncatedSctring.toString();
    this.onAdd.emit({viewingAsMember: false});
    this.router.navigate(['/business/post'], {
      queryParams: { viewingAsMember: false, currentPath: truncatedSctring },
      queryParamsHandling: 'merge',
      relativeTo: this._activated_route
    })


  }

  viewasmember() {
    // this.businessData.viewingAsMember = true;
    const truncatedSctring = this.router.url.slice(0, 15);
    truncatedSctring.toString();
    this.onAdd.emit({viewingAsMember: true});
    this.router.navigate(['/business/post'], {
      queryParams: { viewingAsMember: true, currentPath: truncatedSctring },
      queryParamsHandling: 'merge',
      relativeTo: this._activated_route
    })
  }

  // One-off URL update. This used to subscribe to queryParams (never
  // unsubscribed), so after Follow/Unfollow every later tab click re-fired a
  // same-URL navigate that cancelled the tab's navigation — no NavigationEnd,
  // so the tab highlight stayed on Home. 'merge' keeps the existing params.
  updateQueryparam(updates: { [key: string]: any }) {
    this.router.navigate([], {
      relativeTo: this._activated_route,
      queryParams: updates,
      queryParamsHandling: 'merge',
      preserveFragment: true
    });
  }




  addfollower() {
    const datas: any = {};
    datas.businessId = this.bannerdata.businessId;
    datas.userId = this.userId;
    this.util.startLoader();
    this.API.create("business/add/follower", datas).subscribe((res) => {
      this.util.stopLoader();
      if (res.code === "00000") {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Follower added",
          text: "Now, you are following this business page",
          showConfirmButton: false,
          timer: 2000,
        }).then((result) => {
          this.admindata.isFollow = true;
          localStorage.setItem('isAFollower', 'true')

          this.updateQueryparam({ followed: 'true', isFollower: 'true' });
          // Refetch details → check/admin so the banner's follower count updates now.
          this.companydetailsapicall();

        });
      }
    }, (err) => {

      this.util.stopLoader();
      if (err.status == 500) {
        this.util.stopLoader();
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: 'Something went wrong while adding follower. Please, try again later.',
          showDenyButton: false,
          confirmButtonText: `ok`,
        })
      }
    });
  }



  acceptFollowerRequest() {
    let data: any = {}
    data.businessId = this.bannerdata.businessId
    data.userId = this.userId
    this.API.create('business/follow/accept/request', data).subscribe(res => {

      if (res.code == '00000') {
        this.admindata.isFollowerInvited = false;
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Follower Added',
          text: 'You are now following this business page.',
          showConfirmButton: false,
          timer: 3000
        }).then(() => {
          this.admindata.isFollow = true;
          // this.commonvalues.businessid(this.values);
          this.ngOnInit();
        })
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Oops..',
          text: 'Something went wrong. Please try later.',
          showConfirmButton: false,
          timer: 3000
        })
      }
    }, err => {
      this.util.stopLoader();
      if (err.status == 500) {
        this.util.stopLoader();
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: 'Something went wrong while accepting follower request. Please, try again later.',
          showDenyButton: false,
          confirmButtonText: `ok`,
        })
      }
    })
  }

  rejectFollowerRequest() {
    let data: any = {}
    data.businessId = this.bannerdata.businessId
    data.userId = this.userId
    this.API.create('business/follow/reject/request', data).subscribe(res => {
      if (res.code == '00000') {
        this.admindata.isFollowerInvited = false;

        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Follower Request Rejected',
          text: 'You have rejected the follower invite request.',
          showConfirmButton: false,
          timer: 4000
        }).then(() => {
          this.admindata.isFollow = false;
          // this.commonvalues.businessid(this.values);
          this.ngOnInit();
        })
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Oops..',
          text: 'Something went wrong. Please try later.',
          showConfirmButton: false,
          timer: 3000
        })
      }
    }, err => {
      this.util.stopLoader();
      if (err.status == 500) {
        this.util.stopLoader();
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: 'Something went wrong while rejecting follower request. Please, try again later.',
          showDenyButton: false,
          confirmButtonText: `ok`,
        })
      }
    })
  }

  removefollower() {
    const datas: any = {};
    datas.businessId = this.bannerdata.businessId;
    datas.userId = this.userId;
    this.util.startLoader();
    this.API.create("business/unfollow/follower", datas).subscribe((res) => {
      this.util.stopLoader();

      if (res.code === "00000") {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Follower left",
          text: "You are not following this business page anymore.",
          showConfirmButton: false,
          timer: 2000,
        }).then((result) => {
          this.admindata.isFollow = res.isFollower;
          // this.values.basicDeatils = this.bannerdata;
          // this.values.follow = false;
          // this.values.isFollow = false;

          // this.commonvalues.businessid(this.values);
          localStorage.setItem('isAFollower', 'false')
          this.updateQueryparam({ followed: 'false', isFollower: 'false' });
          // Refetch AFTER the unfollow succeeded (the old ngOnInit() call below the
          // request raced it and re-subscribed trigger$ each time).
          this.companydetailsapicall();

        });
      }
    }, err => {
      this.util.stopLoader();
      if (err.status == 500) {
        this.util.stopLoader();
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: 'Something went wrong while processing your request. Please, try again later.',
          showDenyButton: false,
          confirmButtonText: `ok`,
        })
      }
    });
  }

  mgsBtn() {
    const datas: any = {};
    //datas.businessId = this.bannerdata.businessId;
    datas.refererId = this.bannerdata.businessId;
    datas.type = "BUSINESS";
    this.router.navigate(["message"], { queryParams: datas });
    /*this.API.query("message?type=BUSINESS&teamId=" + datas.businessId).subscribe(res => {
      //// console.log('Message data :' ,res)
      this.router.navigate(['message'], { queryParams: datas })
    });*/
  }
}

